import Button from "../customComponents/Button";
import Paper from "../widgets/Paper";
import InputText from "../customComponents/InputText";
import Select from "../customComponents/Select";
import { useEffect, useState } from "react";
import UploadHotel from "../customComponents/UploadHotel";
import RadioButton from "../customComponents/RadioButton";
import DatePicker from "../customComponents/DatePicker";
import { post } from "../utils/api";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../widgets/Loader";
import { ToastContainer, toast } from "react-toastify";
import SearchSelect from "../customComponents/SerachSelect";
import useRepricePrompt from "./hooks/useRepricePrompt";


const localOptions = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

const AddTransportation = () => {
  const location = useLocation();
  const editData = location.state?.transportData;
  const isEdit = location.state?.isEdit;

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedValue, setSelectedValue] = useState("single");
  const [showSeasonalFields, setShowSeasonalFields] = useState(false);
  const [localOption, setLocalOption] = useState(null);
  const [acOption, setAcOption] = useState(null);
  const [vehicleTypeOption, setVehicleTypeOption] = useState(null);
  //const [showInterStateTax, setShowInterStateTax] = useState(true); // New state to toggle visibility
  const [vehicleTypeOptions, setVehicleTypeOptions] = useState([]); // New state to toggle
  const [formValues, setFormValues] = useState({
    vehicleName: editData?.vehicalname || "",
    noofSeats: editData?.noofseats || "",
    city: editData?.city || "",
    destination: editData?.destination || "",
    baseCharge: editData?.basechargeinr || "",
    totalCharge: editData?.totalcharge || "",
    baseKM: editData?.basekm || "",
    additionalKM: editData?.additionalkm || "",
    additionalCharge: editData?.additionalchargeinr || "",
    interStateTax: editData?.interstatetax || "",
    bata: editData?.batainr || "",
    parking: editData?.parking || "",
    pricePerHead: editData?.priceperhead || "",
    seasonalPrice: editData?.seasonalprice || "",
    interstatecharges: editData?.interstatecharges
  });
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const navigate = useNavigate();
  const { promptReprice, RepriceModal } = useRepricePrompt();
  const [loading, setLoading] = useState(false);
  const [showDestination, setShowDestination] = useState(true);
  const vehicleTypesToHideDestination = [
    "5 Seater car", "7 Seater car", "Tempo traveller 12 seater", "Tempo traveller 18 seater",
    "Mini bus 22 seater", "Bus 30 seater", "Bus 36 seater", "Bus 40 seater",
    "Bus 49 seater", "Volvo 45 seater", "Volvo 55 multiaxil"
  ];
  
  console.log(formValues, "formValues");
  console.log(vehicleTypeOptions, "vehicleTypeOptions");
  console.log(vehicleTypeOption, "vehicleTypeOption");

  console.log(acOption, "acOption");
  console.log(localOptions, "localOptions");
  console.log(localOption, "localOption");

  useEffect(() => {
    fetchVehicleType();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value, // Dynamically update the field value
    }));
  };

  const fetchVehicleType = async () => {
    try {
      const payload = { type: "vehicaltype" };
      const result = await post("/getOptionList", payload);
      const options = [
        ...result.data.map((list) => ({
          label: list.label,
          value: list.label,
          id: list.vehicaltypeid,
        })),
      ];
      setVehicleTypeOptions(options);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleRadioChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleDateChange = (type, date) => {
    if (type == "startdate") {
      setStartDate(date);
    } else {
      setEndDate(date);
    }
  };

  const handleLocalChange = (option) => {
    setLocalOption(option);
    updateTaxFieldVisibility(option, vehicleTypeOption); // Check visibility on change
  };

  const handleVehicleTypeChange = (option) => {
    setVehicleTypeOption(option);
    updateTaxFieldVisibility(localOption, option); // Check visibility on change
  };

  const updateTaxFieldVisibility = (local, vehicleType) => {
    const shouldShowTax = vehicleType?.value === "Bus" && local?.value === "no";
    //setShowInterStateTax(shouldShowTax);

    if (!shouldShowTax) {
      setFormValues((prev) => ({
        ...prev,
        interStateTax: "",
      }));
    }
    if (
      local?.label === "Yes" &&
      vehicleTypesToHideDestination.includes(vehicleType?.label)
    ) {
      setShowDestination(false);
      setFormValues((prev) => ({ ...prev, destination: "" })); 
    } else {
      setShowDestination(true);
    }
  
  };

  const isTrainSelected = vehicleTypeOption?.value === "Train"; // Check if Train is selected
  const isFlightSelected = vehicleTypeOption?.value === "Flight"; // Check if Flight is selected

  const handleAcChange = (option) => {
    setAcOption(option);
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      // Common validations for all vehicle types
      if (!vehicleTypeOption?.label)
        throw new Error("Vehicle type is required.");
      if (!formValues.vehicleName || formValues.vehicleName.trim() === "")
        throw new Error("Vehicle name is required.");
      if (!acOption?.label)
        throw new Error("AC type is required.");
      if (!formValues.noofSeats || isNaN(formValues.noofSeats) || Number(formValues.noofSeats) <= 0) {
        throw new Error("Number of seats must be a valid positive number.");
      }
      if (!formValues.city || formValues.city.trim() === "")
        throw new Error("City is required.");
        
      // Vehicle specific validations
      const selectedVehicleType = vehicleTypeOption?.label;
      if (!isFlightSelected && !isTrainSelected && vehicleTypesToHideDestination.includes(selectedVehicleType)) {
        // Validations for regular vehicles (Bus, Car etc.)
        //if (!acOption?.label) throw new Error("AC type is required.");
        if (!localOption?.label)
          throw new Error("Local INR option is required.");
      }
      if (showDestination && localOption?.label !== "Yes" && (!formValues.destination || formValues.destination.trim() === "")) {
        throw new Error("Destination is required.");
      }
      if (!isFlightSelected && !isTrainSelected && vehicleTypesToHideDestination.includes(selectedVehicleType)) {
        if (
          localOption?.value === "no" &&
          showDestination &&
          !isTrainSelected &&
          !isFlightSelected &&
          (!formValues.interstatecharges || isNaN(formValues.interstatecharges) || Number(formValues.interstatecharges) <= 0)
        ) {
          throw new Error("Interstate charges must be a valid positive number.");
        }
      }
      if (!formValues.baseCharge || isNaN(formValues.baseCharge) || Number(formValues.baseCharge) <= 0) {
        throw new Error("Base charge must be a valid positive number.");
      }  
      if (!isFlightSelected && !isTrainSelected && vehicleTypesToHideDestination.includes(selectedVehicleType)) {
        if (!formValues.baseKM || isNaN(formValues.baseKM) || Number(formValues.baseKM) <= 0) {
          throw new Error("Base KM must be a valid positive number.");
        }
        if (!formValues.bata || isNaN(formValues.bata) || Number(formValues.bata) <= 0) {
          throw new Error("Bata charge must be a valid positive number.");
        }
        if (!formValues.parking || isNaN(formValues.parking) || Number(formValues.parking) <= 0) {
          throw new Error("Parking charge must be a valid positive number.");
        }
      }
      if (!formValues.pricePerHead || isNaN(formValues.pricePerHead) || Number(formValues.pricePerHead) <= 0) {
        throw new Error("Price per head must be a valid positive number.");
      }

      // Seasonal price validations
      if (showSeasonalFields) {
        if (!startDate) throw new Error("Season start date is required.");
        if (!endDate) throw new Error("Season end date is required.");
        if (!formValues.seasonalPrice)
          throw new Error("Seasonal price is required.");
      }

      const payload = {
        vehicaltypeid: vehicleTypeOptions.find(
          (list) => list.label === vehicleTypeOption?.label
        )?.id,
        actype: acOption?.label ? acOption?.label : null,
        localinr:
          !isFlightSelected && !isTrainSelected ? localOption?.label : null,
        vehicalname: formValues.vehicleName,
        noofseats: formValues.noofSeats,
        destination: formValues.destination,
        city: formValues.city,
        basekm:
          !isFlightSelected && !isTrainSelected ? formValues.baseKM : null,
        basechargeinr: formValues.baseCharge,
        additionalkm: formValues.additionalKM,
        additionalchargeinr: formValues.additionalCharge,
        priceperhead: formValues.pricePerHead,
        interstatetax: formValues.interStateTax,
        batainr: !isFlightSelected && !isTrainSelected ? formValues.bata : null,
        parking:
          !isFlightSelected && !isTrainSelected ? formValues.parking : null,
        seasonstart: showSeasonalFields ? startDate : null,
        seasonend: showSeasonalFields ? endDate : null,
        seasonalprice: showSeasonalFields ? formValues.seasonalPrice : null,
        totalcharge: formValues.totalCharge,
        type: isEdit ? "update" : "insert",
        transportid: editData?.transportid,
        overheadprice: formValues.overheadPrice,
        interstatecharges: formValues?.interstatecharges
      };
      console.log("Overhead Price Value:", formValues.overheadPrice); // Debug here
      console.log("-----AAAA", payload);
      const response = await post("/addTransport", payload);
      toast.success(
        isEdit ? "Vehicle updated successfully!" : "Vehicle added successfully!"
      );
      promptReprice(response, () => navigate("/transportation"));
    } catch (error) {
      toast.error(
        error.message ||
          (isEdit ? "Failed to update vehicle" : "Failed to add vehicle")
      );
    } finally {
      setLoading(false);
    }
  };

  // Add this function before the return statement
  const calculateTotalCost = () => {
    const {
      baseCharge,
      additionalKM,
      additionalCharge,
      bata,
      parking,
      interStateTax,
      noofSeats,
      // seasonalPrice,
    } = formValues;

    // Convert string values to numbers
    const days = 1;
    const baseCharges = Number(baseCharge);
    const addKms = Number(additionalKM);
    const addCharges = Number(additionalCharge);
    const bataAmount = Number(bata);
    const parkingAmount = Number(parking);
    const interStateTaxAmount = Number(interStateTax);
    const seats = Number(noofSeats);
    // const seasonalPriceAmount = Number(seasonalPrice || 0);

    let totalCost = 0;

    totalCost = baseCharges / seats;

    // if (localOption?.value === "yes") {
    //   // Local Trip Calculation
      
    //     (days * baseCharges +
    //       addKms * addCharges +
    //       bataAmount +
    //       parkingAmount) /
    //     seats;
    // } else {
    //   // Interstate Trip Calculation
    //   totalCost =
    //     (days * baseCharges +
    //       addKms * addCharges +
    //       bataAmount +
    //       parkingAmount +
    //       interStateTaxAmount) /
    //     seats;
    // }

    return totalCost;
  };

  const calculateOverheadPrice = () => {
    const additionalKM = Number(formValues.additionalKM) || 0;
    const additionalCharge = Number(formValues.additionalCharge) || 0;
    const interstatecharges = Number(formValues.interstatecharges) || 0;
    const bata = Number(formValues.bata) || 0;
    const parking = Number(formValues.parking) || 0;
  
    const overhead = (additionalKM * additionalCharge) + interstatecharges + bata + parking;
    return overhead;
  };
  

  useEffect(() => {
    if (editData && vehicleTypeOptions.length > 0) {

      const vehicleType = vehicleTypeOptions.find(
        (option) => option.label === editData.vehicaltype
      );
      setVehicleTypeOption(vehicleType);

      const acTypeOption = localOptions.find(
        (option) => option.label === editData.actype
      );
      setAcOption(acTypeOption);

      const localTypeOption = localOptions.find(
        (option) => option.label === editData.localinr
      );
      setLocalOption(localTypeOption);

      if (editData.seasonstart) setStartDate(new Date(editData.seasonstart));
      if (editData.seasonend) setEndDate(new Date(editData.seasonend));
      setShowSeasonalFields(!!editData.seasonalprice);
    }
  }, [editData, vehicleTypeOptions]);

  // Add this effect to update total cost when relevant fields change
  useEffect(() => {
    const total = calculateTotalCost();
    const overhead = calculateOverheadPrice();
    setFormValues((prev) => ({
      ...prev,
      pricePerHead: total,
      overheadPrice: overhead,
    }));
  }, [
    formValues.baseKM,
    formValues.baseCharge,
    formValues.additionalKM,
    formValues.additionalCharge,
    formValues.bata,
    formValues.parking,
    formValues.interStateTax,
    formValues.noofSeats,
    formValues.seasonalPrice,
    localOption,
  ]);

  return (
    <div>
      {RepriceModal}
      {loading ? <Loader /> : <></>}
      <div className="block md:block lg:flex justify-between">
        <div>
          <h2 className="text-primary-black text-[24px] font-semibold">
            {isEdit ? "Edit Transportation" : "Add Transportation"}
          </h2>
          <p className="text-[12px]">
            <span className="font-bold">Transportation</span> /
            <span className="font-regular">
              {isEdit ? "Edit" : "Add"} Transportation
            </span>
          </p>
        </div>

        <div className="flex mt-4 justify-end gap-4">
          <Button type="primary" label="Save" onClick={handleSave} />
          <Button
            type="secondary"
            label="Cancel"
            onClick={() => navigate("/transportation")}
          />
        </div>
      </div>
      <Paper className="my-8 pt-6 pb-6">
        <h1 className="text-[16px] font-semibold">Upload Type</h1>
        <div className="mt-4 space-y-4">
          <RadioButton
            name="customRadio"
            value="single"
            checked={selectedValue === "single"}
            onChange={handleRadioChange}
            label="Single Upload"
          />
          <RadioButton
            name="customRadio"
            value="bulk"
            checked={selectedValue === "bulk"}
            onChange={handleRadioChange}
            label="Bulk Upload"
            className={"ml-4"}
          />
        </div>
        {selectedValue === "single" && (
          <>
            <Paper className="my-8 border">
              <h1 className="text-[20px] font-bold mb-4">Transportation Details</h1>
              <div className="grid grid-flow-row-dense grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
                <div>
                  <label className="text-[16px] font-semibold mb-2">
                    Transportation Type<span className="text-red-500">*</span>
                  </label>
                  <SearchSelect
                    options={vehicleTypeOptions}
                    value={vehicleTypeOption}
                    onChange={handleVehicleTypeChange}
                    placeholder="Select Type..."
                  />
                </div>
                <div>
                  <label className="text-[16px] font-semibold">
                    Name<span className="text-red-500">*</span>
                  </label>
                  <InputText
                    value={formValues?.vehicleName}
                    placeholder="Name..."
                    name="vehicleName"
                    onChange={handleChange}
                  />
                </div>
                {/*(isTrainSelected || isFlightSelected) && (*/
                  <div>
                    <label className="text-[16px] font-semibold mb-2">
                      AC<span className="text-red-500">*</span>
                    </label>
                    <Select
                      placeholder="Select..."
                      options={localOptions}
                      value={acOption}
                      onChange={handleAcChange}
                    />
                  </div>
                /*)*/}

                <div>
                  <label className="text-[16px] font-semibold mb-2">
                    No. of Seats<span className="text-red-500">*</span>
                  </label>
                  <InputText
                    value={formValues?.noofSeats}
                    placeholder="Enter Number..."
                    name="noofSeats"
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label className="text-[16px] font-semibold">
                    City (Source)<span className="text-red-500">*</span>
                  </label>
                  <InputText
                    value={formValues?.city}
                    placeholder="Select City..."
                    name="city"
                    onChange={handleChange}
                  />
                </div>

                {isTrainSelected || isFlightSelected ? null : (
                  <div>
                    <label className="text-[16px] font-semibold">
                      Local<span className="text-red-500">*</span>
                    </label>
                    <Select
                      options={localOptions}
                      value={localOption}
                      onChange={handleLocalChange}
                      placeholder="Select..."
                    />
                  </div>
                )}
                {showDestination && localOption?.label !== "Yes" && (
                  <div>
                    <label className="text-[16px] font-semibold">
                      Destination<span className="text-red-500">*</span>
                    </label>
                    <InputText
                      value={formValues?.destination}
                      placeholder="Select City..."
                      name="destination"
                      onChange={handleChange}
                    />
                  </div>
                )}
                {showDestination && localOption?.label !== "Yes" && !isTrainSelected && !isFlightSelected && (
                  <div>
                    <label className="text-[16px] font-semibold">
                      Interstate Charges<span className="text-red-500">*</span>
                    </label>
                    <InputText
                      value={formValues?.interstatecharges}
                      placeholder="Enter Amount..."
                      name="interstatecharges"
                      onChange={handleChange}
                    />
                  </div>
                )}
                <div>
                  <label className="text-[16px] font-semibold">
                    Base Charge<span className="text-red-500">*</span>
                  </label>
                  <InputText
                    value={formValues?.baseCharge}
                    placeholder="Enter Amount..."
                    name="baseCharge"
                    onChange={handleChange}
                  />
                </div>

                {isTrainSelected || isFlightSelected ? null : (
                  <>
                    <div>
                      <label className="text-[16px] font-semibold">
                        Base KM<span className="text-red-500">*</span>
                      </label>
                      <InputText
                        value={formValues?.baseKM}
                        placeholder="Enter..."
                        name="baseKM"
                        onChange={handleChange}
                      />
                    </div>
                  </>
                )}

                  <div>
                      <label className="text-[16px] font-semibold">
                        Price per head per day<span className="text-red-500">*</span>
                      </label>
                      <InputText
                        value={formValues?.pricePerHead || ""}
                        placeholder="Enter Amount..."
                        name="pricePerHead"
                        onChange={handleChange}
                      />
                  </div>
              </div>

              <div className="grid grid-flow-row-dense grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                {isTrainSelected || isFlightSelected ? null : (
                  <>
                    <div>
                      <label className="text-[16px] font-semibold">
                        Additional KM
                      </label>
                      <InputText
                        value={formValues?.additionalKM}
                        placeholder="Enter Amount..."
                        name="additionalKM"
                        onChange={handleChange}
                      />
                    </div>
                    <div>
                      <label className="text-[16px] font-semibold">
                        Additional Charge
                      </label>
                      <InputText
                        value={formValues?.additionalCharge}
                        placeholder="Enter Amount..."
                        name="additionalCharge"
                        onChange={handleChange}
                      />
                    </div>
                  </>
                )}

                {/* {showInterStateTax && (
                  <div>
                    <label className="text-[16px] font-semibold">
                      Inter State Tax
                      <span className="text-red-500">*</span>
                    </label>
                    <InputText
                      value={formValues?.interStateTax}
                      placeholder="Enter Amount..."
                      name="interStateTax"
                      onChange={handleChange}
                    />
                  </div>
                )} */}

                {isTrainSelected || isFlightSelected ? null : (
                  <>
                    <div>
                      <label className="text-[16px] font-semibold">
                        Bata (2 bata)<span className="text-red-500">*</span>
                      </label>
                      <InputText
                        value={formValues?.bata}
                        placeholder="Enter Amount..."
                        name="bata"
                        onChange={handleChange}
                      />
                    </div>
                    <div>
                      <label className="text-[16px] font-semibold">
                        Toll & Parking <span className="text-red-500">*</span>
                      </label>
                      <InputText
                        value={formValues?.parking}
                        placeholder="Enter Amount..."
                        name="parking"
                        onChange={handleChange}
                      />
                    </div>
                    <div>
                      <label className="text-[16px] font-semibold">
                        Overhead price<span className="text-red-500">*</span>
                      </label>
                      <InputText
                        value={formValues?.overheadPrice}
                        placeholder="Enter Amount..."
                        name="overheadPrice"
                        onChange={handleChange}
                      />
                    </div>
                  </>
                )}
                
              </div>
              
            </Paper>
          </>
        )}
        {selectedValue === "bulk" && (
          <Paper className="my-8 border">
            <h1 className="text-[20px] font-bold mb-4">Upload File</h1>
            <UploadHotel />
          </Paper>
        )}
      </Paper>
      <ToastContainer />
    </div>
  );
};

export default AddTransportation;
